import { styled } from "@mui/material";
const GreedyBox = styled("div", {
  name: "GreedyBox",
  skipSx: true,
  slot: "GreedyBox"
})`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  height: 100%;
  width: 100%;
`;
export {
  GreedyBox
};
//# sourceMappingURL=GreedyBox.js.map
